<template>
  <div>
    <div class="card-box" v-if="coupon.couponId">
      <ActivityCard
        :item="detail"
        :shareId="shareId"
        v-if="detail.activityId"
      />
      <div style="background:#fff;margin-bottom:8px">
        <div class="coupon-box">
          <div class="coupon-box-item">
            <CouponType :info="coupon" useSlot></CouponType>
          </div>
        </div>
      </div>
      <div style="background:#fff;">
        <div class="card-box-title">
          <span class="line"></span>
          <span class="name">规则说明</span>
          <span class="line"></span>
        </div>
        <div class="rule-box">
          {{ coupon.instructions }}
        </div>
        <div class="detail-images">
          <img
            mode="widthFix"
            :src="item"
            v-for="(item, index) in coupon.goodsDetailImages"
            :key="index"
          />
        </div>
      </div>
      <div class="footer flex-center" v-if="!noUse">
        <LinkWeappBtn
          :url="`cardBag/couponDetail.html?id=${couponId}&shareId=${shareId}`"
        >
          <script type="text/wxtag-template">
              <style>
                .apply-btn {
                  width: 343px;
                  background: linear-gradient(270deg, #306FE2 24.05%, #1F7DDE 73.62%);
                  color: #fff;
                  font-size: 16px;
                  height: 44px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-radius: 40px;
                  border: none;
                }
              </style>
              <button class="apply-btn"> 立即领取
            </button>
          </script>
        </LinkWeappBtn>
      </div>
    </div>
    <van-popup v-model="qrModel" closeable :style="{ width: '100%' }">
      <div class="qr_code">
        <img :src="url" alt="" />
        <div>微信中长按识别小程序码</div>
        <div>领取卡券</div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import LinkWeappBtn from '../components/LinkWeappBtn'
import CouponType from '../components/CouponType'
export default {
  data() {
    return {
      qrModel: false,
      couponId: '',
      type: '3',
      from: '',
      activityId: '',
      params: {},
      loading: false,
      noUse: false,
      shareId: '',
      disabled: false,
      showShare: false,
      couponInfo: {},
      packageId: '',
      cardBag: {},
      url: '',
      detail: {},
      coupon: {},
    }
  },
  // 局部注册的组件
  components: {
    LinkWeappBtn,
    CouponType,
  },
  async mounted() {
    if (!this.$root.$data.store.state.isInitWx) {
      this.$root.$data.store.initwx(true, this.$route.query.code)
    }
    this.couponId = this.$route.query.id
    this.shareId = this.$route.query.shareId
    this.getCouponDetails()
    this.readyShare()
  },
  methods: {
    // md5解密活动id
    getMd5(code) {
      return new Promise((s) => {
        this.$http
          .get('aocampaign/openapi/common/parms/restore?key=' + code)
          .then((res) => {
            console.log('%c 解密', 'color:orange', res.data)
            const ids = res.data.split('&')
            this.couponId = ids[0]
            this.shareId = ids[1]
            console.log('%c ids', 'color:orange', this.packageId, ids[1])
            s()
          })
      })
    },
    readyShare() {
      window.wx.ready(async () => {
        const shareUrl = `${location.origin}${location.pathname}#/couponDetail?id=${this.couponId}&shareId=${this.shareId}`
        //需在用户可能点击分享按钮前就先调用
        window.wx.onMenuShareAppMessage({
          title: this.coupon.onlineName, // 分享标题
          desc: this.coupon.onlineDescription, // 分享描述
          link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.coupon.bannerUrl, // 分享图标
          success: () => {
            // 用户点击了分享后执行的回调函数
          },
        })
        window.wx.onMenuShareTimeline({
          title: this.coupon.onlineName, // 分享标题
          link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.coupon.bannerUrl, // 分享图标
          success: () => {
            // 用户点击了分享后执行的回调函数
          },
        })
      })
    },
    // 获取卡券详情
    getCouponDetails() {
      this.$http
        .get(`aocampaign/openapi/coupon/info/${this.couponId}`)
        .then((res) => {
          if (!res.data) {
            return false
          }
          // 需要对详情图片字段进行转化成数组
          this.coupon = res.data
           //图片
          if (res.data.goodsDetailImages &&res.data.goodsDetailImages.indexOf('[') == -1) {
              console.log('indexOf',res.data.goodsDetailImages)
              this.coupon.goodsDetailImages = res.data.goodsDetailImages
            ? res.data.goodsDetailImages.split(',')
            : ''
          }else{
            if(res.data.goodsDetailImages){
              console.log(res.data.goodsDetailImages)
              this.coupon.goodsDetailImages=JSON.parse(res.data.goodsDetailImages)
            }
          }
        })
    },
    async getWxcode() {
      this.url = await this.$share.getPosterNew(
        {
          id: this.couponId,
          shareId: this.shareId,
        },
        'cardBag/couponDetail'
      )
      this.qrModel = true
    },
  },
}
</script>

<style lang="less" scoped>
.card-box {
  position: relative;
  padding-bottom: 120px;
}
.footer {
  padding: 12px 0 20px 0;
  justify-content: center;
  .btn {
    padding: 0 6px;
  }
  .active {
    justify-content: center;
  }
}
.items {
  width: 60px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 11px;
  line-height: 20px;
}
.card-box-title {
  padding: 12px 0;
  text-align: center;
  .line {
    display: inline-block;
    width: 32px;
    height: 1px;
    background: #c8c9cc;
    vertical-align: middle;
  }
  .name {
    font-size: 13px;
    margin: 0 8px;
    font-weight: 600;
  }
}
.coupon-box {
  padding: 20px;
}
.rule-box {
  padding: 0 20px 20px;
  font-size: 14px;
  word-break: break-all;
  word-wrap: break-word;
  line-height: 22px;
}
.detail-images img {
  width: 100%;
}
</style>
